module.exports = __webpack_public_path__ + "img/ResumeTemp4.a4a8e31e.png";